var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23.5,
    r: 23,
    fill: "#535353"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_10437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 11.24C18.688 11.24 15.16 14.712 15.16 18.996C15.16 28.124 22.328 34.368 22.636 34.648C22.832 34.816 23.168 34.816 23.364 34.648C23.672 34.368 30.84 28.096 30.84 18.996C30.84 14.712 27.312 11.24 23 11.24ZM23 33.444C21.544 32.044 16.28 26.444 16.28 18.996C16.28 15.328 19.304 12.36 23 12.36C26.696 12.36 29.72 15.328 29.72 18.996C29.72 26.444 24.456 32.044 23 33.444ZM23 14.6C20.536 14.6 18.52 16.616 18.52 19.08C18.52 21.544 20.536 23.56 23 23.56C25.464 23.56 27.48 21.544 27.48 19.08C27.48 16.616 25.464 14.6 23 14.6ZM23 22.44C21.152 22.44 19.64 20.928 19.64 19.08C19.64 17.232 21.152 15.72 23 15.72C24.848 15.72 26.36 17.232 26.36 19.08C26.36 20.928 24.848 22.44 23 22.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.323 -94.5998V376.92H-30.1975V-94.5998H469.323ZM471.562 -96.8398H-32.4375V379.16H471.562V-96.8398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_10437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.88f3a29a784a177980fe18dd67c517f8.svg";
export { ForwardRef as ReactComponent };